import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  //public currentAlert$ = new Subject<Alert>();
  public currentAlert!: Alert;
  public currentDialog!: Dialog;
  //showOKCancel: Boolean
  public OKPressed = new Subject<Dialog>();
  public YESPressed = new Subject<Dialog>();
  //public NOPressed = new Subject<Dialog>();
  showChangeTornDates!: Boolean;
  showCreateNewTorn!: Boolean;
  showOKCancel!: Boolean;
  showCancelButton!: Boolean;
  showAnnouncementDialog!: Boolean;
  showCreateNewDraw!: Boolean;
  showChangeCalendarTextDialog!: Boolean;

  constructor() { }

  showDialog(Title: string, Buttons: string, Inputs: string[], Message: string, type: string) {
    switch (type) {
      // case "showChangeTornDates":
      //   this.showChangeTornDates = true;
      //   break;
      // case "showCreateNewTorn":
      //   this.showCreateNewTorn = true;
      //   break;
      case "Standard":
        this.showOKCancel = true;
        break;
      case "Announcements":
        this.showAnnouncementDialog = true;
        break;
      // case "showCreateNewDraw":
      //   this.showCreateNewDraw = true;
      //   break;
    }
    this.showCancelButton = false;
    if (Buttons == 'OKCancel') {
      this.showCancelButton = true;
    }

    var InputResponses = [] as string[];
    if (Inputs) {
      //InputResponses = [] as string[];
      Inputs.forEach(response => {
        InputResponses.push("");
      });
    }
    this.currentDialog = { Buttons: Buttons, title: Title, Inputs: Inputs, Message: Message, InputResponses: InputResponses, Type: type };
  }

  // showAlert(doing, type, Message, error) {
  //   console.log(doing + " - " + error.error?.message);
  //   if (error.status != 0) {
  //     const alert = { type, title: doing, Message, error };
  //     this.currentAlert = alert;
  //     this.currentAlert$.next(alert);  // emit
  //   }
  // }

  showAlert(doing: string, type: string, Message: string, error: any) {
    console.log(doing + " - " + error?.error?.message);

    if (error.status != 0) {//so that refused connections don't show error
      this.currentAlert = { type: type, title: doing, Message: Message, error: this.getErrorText(error) };
    }
    //this.showDialog("Error", "OK", null, Message, "Standard");
  }

  showSimpleAlert(Message: string) {
    this.currentAlert = { type: "Success", title: "Infomation", Message: Message, error: "" };
  }

  DialogOKPressed() {
    this.OKPressed.next(this.currentDialog);
    this.currentDialog = undefined as any;
    this.currentAlert = undefined as any;
  }

  DialogYESPressed() {
    this.YESPressed.next(this.currentDialog);
  }

  // DialogNOPressed() {
  //   this.NOPressed.next(this.currentDialog);
  // }

  getErrorText(error: any): any {
    if (!error) return '';
  
    if (typeof error === 'string') {
      return error;
    }

    if (error.error) {
      if (error.error.errors) {
        return Object.values(error.error.errors)
          .flat()
          .join('\n');
      }
    }
    if (Array.isArray(error)) {
      return error.join('\n');
    }
  
    if (error.errors) {
      if (Array.isArray(error.errors)) {
        return error.errors.join('\n');
      }
  
      if (typeof error.errors === 'object') {
        return Object.values(error.errors)
          .flat()
          .join('\n');
      }
      if (error.message && typeof error.message === 'string') {
      return error.message;
    }
    }
  
    try {
      return JSON.stringify(error, null, 2);
    } catch {
      return 'An unexpected error occurred.';
    }
  }
}

export class Alert {
  type!: string;
  title!: string;
  Message!: string;
  error: any;
}

export class Dialog {
  Buttons!: string;
  Inputs!: string[];
  title!: string;
  Message!: string;
  InputResponses!: string[];
  Type!: string;
}
